import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { useEditorChrome } from '../../core/context/EditorChromeContext';
import { useFeatureEnabled } from '../../core/context/FeaturesContext';
import { registerSubmit } from './registerSubmit';

/** Always on: "submitting" deactivates the editor, which reports the value through `onBlur`; see `registerSubmit`. */
export const SubmitPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const { requestBlur } = useEditorChrome();
  const singleLine = useFeatureEnabled('singleLine');

  useEffect(() => registerSubmit(editor, requestBlur, { submitOnEnter: singleLine }), [editor, requestBlur, singleLine]);

  return null;
};
